<template>
    <UserAddTabAccount class="mt-2 pt-75" />
</template>

<script>
import { BTab, BTabs, BCard, BAlert, BLink, } from 'bootstrap-vue'
import { ref, onUnmounted, provide } from '@vue/composition-api'
import UserAddTabAccount from './UserAddTabAccount.vue'
import userStoreModule from '../userStoreModule'
import store from '@/store'

export default {
    components: { BTab, BTabs, BCard, BAlert, BLink, UserAddTabAccount },
    setup(){
        const USER_MODULE = 'users'
        const roles = ref(null)
        const groups = ref(null)
        const user = ref({
            name: '',
            username: '',
            surname: '',
            email: '',
            status: '',
            role: null,
            groups: null,
            password: ''
        })

        provide('user', user)
        provide('roles', roles)
        provide('groups', groups)

        if(!store.hasModule(USER_MODULE)) store.registerModule(USER_MODULE, userStoreModule)

        onUnmounted(() => {
            if(store.hasModule(USER_MODULE)) store.unregisterModule(USER_MODULE)
        })

        store.dispatch('users/createUser').then(response => {
            roles.value = response.data.roles
            groups.value = response.data.groups
    })

        return {

        }
    }
}
</script>

<style>

</style>
